module.exports = __webpack_public_path__ + "img/1511472772.07fed27b.jpg";